<template>
  <div :id="canvasId" style="height: 100%; width: 100%" />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HighchartsMixin from "@/mixins/Highcharts.js";
import Highcharts from "highcharts";

export default {
  name: "",
  props: ["value","canvasId"],
  mixins: [HighchartsMixin],
  components: {},
  data() {
    return {
      chart: null,
      isLoading: false
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    ...mapGetters(["getUser"]),
  },

  methods: {
    plotCannabinoidsAndTerpenes : function() {
      if (this.chart) {
        this.chart.destroy();
      }

      if (!document.getElementById(this.canvasId)) {
        setTimeout(this.plotCannabinoidsAndTerpenes, 50);
        return;
      }

      let series = [
        {
          name: "Cannabinoids",
          data: [],
        },
        {
          name: "Terpenes",
          data: [],
        },
      ];

      let selectedRecs = this.value;
     
      let categories = selectedRecs.map((a) =>   a.productName + ' / ' + a.ResultReleaseDateTime.split('T')[0]);

      for (let i = 0; i < selectedRecs.length; i++) {
        series[0].data.push(selectedRecs[i].totalCananabinoids);
        series[1].data.push(-1 * selectedRecs[i].totalTerpenes);
      }

      this.series = series;

      let title = this.hideTitle
        ? null
        : { text: "Estimated Harvest Dry Weights" };

      this.chart = Highcharts.chart(this.canvasId, {
        credits: {
          enabled: false,
        },
       
        exporting: false,
        chart: {
          type: "bar",
          styledMode: true
        },
        title: {
          text: null,
        },
        xAxis: [
          {
            categories: categories,
            reversed: false,
            labels: {
              step: 1,
            },
            accessibility: {
              description: "Cannabinoid %",
            },
          },
        ],
        yAxis: {
          title: {
            text: null,
          },

          labels: {
            formatter: function () {
              return Math.abs(this.value) + "%";
            },
          },
          accessibility: {
            description: "Percentage",
            rangeDescription: "Percentage",
          },
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.category +
              "</b><br/>" +
              this.series.name +
              " : " +
              Highcharts.numberFormat(Math.abs(this.point.y), 1) +
              "%"
            );
          },
        },

        series: this.series,
      });
    },

    refresh() {
      this.plotCannabinoidsAndTerpenes();
    },
  },
  watch: {
   
    value(newVal, oldVal) {
      if (document.getElementById(this.canvasId)) {
        this.refresh();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
